// extracted by mini-css-extract-plugin
module.exports = {"giftManual":"w2uSsm"};